import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const PublicAppApi = createApi(config.PUBLIC_URL);

export default PublicAppApi;
